module.exports = __webpack_public_path__ + "static/media/_T10-Mongoose_js.3339ec8b.png";